<template>
  <div class="page-container">
    <div id="searchArea">
      <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList(1)">
        <div class="pb16">
          <el-button type="primary" @click="addOrUpdateHandle()" v-if="isAuth('sys:client:save')">Add Client code</el-button>
        </div>
        <div>
          <el-form-item>
            <el-input v-model="dataForm.keyword" :placeholder="kwPlaceHolder" class="wd500 input-with-select-lg" clearable>
              <el-select v-model="dataForm.kwType" slot="prepend" placeholder="please select">
                <el-option v-for="item in kwTypes" :key="item.value" :label="item.title" :value="item.value"></el-option>
              </el-select>
            </el-input>
          </el-form-item>
          <el-form-item>
            <client-code-select-remote-search v-model="dataForm.clientCode" placeholder="Client Code"></client-code-select-remote-search>
          </el-form-item>
          <el-form-item>
            <uen-select-remote-search v-model="dataForm.uen" placeholder="UEN"></uen-select-remote-search>
          </el-form-item>
          <el-form-item>
            <el-select v-model="dataForm.country" clearable filterable placeholder="Country">
              <el-option v-for="item in countryList" :key="item.value" :label="item.title" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-select v-model="dataForm.coordinatorIds" placeholder="select coordinator" filterable multiple clearable>
              <el-option label="Unassigned" value="unassigned"></el-option>
              <el-option v-for="item in userList" :key="`client-option-${item.id}`" :label="item.nickname || item.username" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-date-picker-range
              :startDate="dataForm.createTimeStart"
              :endDate="dataForm.createTimeEnd"
              startPlaceholder="Create (Start Date)"
              endPlaceholder="Create (End Date)"
              @startSelectChange="
                val => {
                  dataForm.createTimeStart = val;
                }
              "
              @endSelectChange="
                val => {
                  dataForm.createTimeEnd = val;
                }
              "
            ></el-date-picker-range>
          </el-form-item>
          <el-form-item>
            <el-date-picker-range
              :startDate="dataForm.passTimeStart"
              :endDate="dataForm.passTimeEnd"
              startPlaceholder="Pass (Start Date)"
              endPlaceholder="Pass (End Date)"
              @startSelectChange="
                val => {
                  dataForm.passTimeStart = val;
                }
              "
              @endSelectChange="
                val => {
                  dataForm.passTimeEnd = val;
                }
              "
            ></el-date-picker-range>
          </el-form-item>
          <div style="display: inline-block">
            <el-form-item>
              <el-select v-model="dataForm.introducedBy" clearable placeholder="Introduced By" class="controlLeft" @change="introducedByChange">
                <el-option v-for="item in introducedByList" :label="item.title" :value="item.value" :key="item.title"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item class="fml10" v-if="dataForm.introducedBy">
              <el-select-all
                class="controlRight"
                :width="220"
                :optionList="commissionRequiredArr"
                placeholder="Commission"
                @elSelectAllChange="
                  list => {
                    dataForm.commission = list;
                  }
                "
              ></el-select-all>
            </el-form-item>
          </div>
          <el-form-item>
            <el-select v-model="dataForm.status" multiple clearable placeholder="Status">
              <el-option v-for="item in clientCodeStatusList" :key="item.value" :label="item.title" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-select v-model="dataForm.tagIds" multiple clearable placeholder="Marketing Tags">
              <el-option v-for="item in tagInfoList" :key="`Tags-${item.id}`" :label="item.tagName" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button icon="el-icon-search" type="primary" plain v-debounce @click="getDataList(1)">Search</el-button>
          </el-form-item>
        </div>
      </el-form>
    </div>
    <div>
      <el-table
        max-height="640"
        :data="dataList"
        v-loading="dataListLoading"
        @sort-change="tableSortChange"
        :default-sort="{ prop: 'createTime', order: 'descending' }"
        style="width: 100%"
      >
        <el-table-column prop="clientCode" align="center" label="Client Code" width="125" fixed="left" sortable="custom">
          <template slot-scope="scope">
            <p class="lh20 mt0 mb0">{{ scope.row.clientCode }}</p>
            <el-link type="primary" :underline="false" @click="openLinkedApplymentyModal(scope.row)">(Track)</el-link>
          </template>
        </el-table-column>
        <el-table-column prop="uen" align="center" label="UEN" min-width="120" fixed="left"></el-table-column>
        <el-table-column prop="country" align="center" label="Country" min-width="120" fixed="left"></el-table-column>
        <el-table-column prop="companyName" align="center" label="Company Name" min-width="140" fixed="left"></el-table-column>
        <el-table-column prop="coordinatorList" align="center" label="Coordinator" width="200" fixed="left">
          <template slot-scope="scope">
            <span v-if="scope.row.coordinatorList">{{ scope.row.coordinatorList.map(item => item.nickname || item.username).join(", ") }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" align="center" label="Create Time" min-width="130" sortable="custom"></el-table-column>
        <el-table-column prop="passTime" align="center" label="Pass Time" min-width="120" sortable="custom"></el-table-column>
        <el-table-column prop="rejectTime" align="center" label="Failed Time" min-width="130" sortable="custom"></el-table-column>
        <el-table-column prop="inactiveTime" align="center" label="Inactive Time" min-width="140" sortable="custom"></el-table-column>
        <el-table-column prop="introducer" align="center" label="Introducer" min-width="100"></el-table-column>
        <el-table-column align="center" label="Introduced By" min-width="120">
          <template slot-scope="scope">
            <p>{{ introducedByFormat(scope.row.introducedBy) }}</p>
          </template>
        </el-table-column>
        <el-table-column align="center" label="Commission" min-width="130">
          <template slot-scope="scope">
            <p v-for="item in scope.row.commissionList" :key="`commission-${scope.row.id}-${item.id}`" class="mt0 mb0">
              {{ item.name }} - {{ multiply(item.commissionRate) }}
              <el-popover placement="bottom" trigger="hover" v-if="item.remark">
                <div class="fs12 lh20 enbr" style="max-width: 300px">{{ item.remark }}</div>
                <span slot="reference" class="fs14 lightGray el-icon-info"></span>
              </el-popover>
            </p>
          </template>
        </el-table-column>
        <el-table-column prop="relationshipRemark" align="center" label="Relationship" min-width="260"></el-table-column>
        <el-table-column align="center" label="Billing Addresses" min-width="200">
          <template slot-scope="scope">
            <div v-if="scope.row.billingInfoList?.length > 0">
              <p v-for="(item, index) in scope.row.billingInfoList" :key="`billing-${scope.row.id}-${index}`">
                <span class="mr4">{{ item.billingAddress }}</span>
                <el-popover placement="bottom" trigger="hover">
                  <div class="fs12 lh20 enbr" style="max-width: 300px">
                    <div>Country: {{ item.billingCountry }}</div>
                    <div>Zone: {{ item.billingZone }}</div>
                    <div>Postal/ZIP Code: {{ item.billingPostalCode }}</div>
                  </div>
                  <span slot="reference" class="fs14 lightGray el-icon-info"></span>
                </el-popover>
              </p>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="attention" align="center" label="Attention" min-width="100"></el-table-column>
        <el-table-column align="center" label="Contact Persons" min-width="200">
          <template slot-scope="scope">
            <div v-if="scope.row.contactInfoList?.length > 0">
              <p v-for="(item, index) in scope.row.contactInfoList" :key="`contact-${scope.row.id}-${index}`">
                <span class="mr4">{{ item.contactName }}</span>
                <el-popover placement="bottom" trigger="hover">
                  <div class="fs12 lh20 enbr" style="max-width: 300px">
                    <div>Email: {{ item.contactEmail }}</div>
                    <div>Receive Marketing Emails: {{ item.isReceiveEmail ? "Yes" : "No" }}</div>
                    <div>Position: {{ item.contactPosition }}</div>
                  </div>
                  <span slot="reference" class="fs14 lightGray el-icon-info"></span>
                </el-popover>
              </p>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="remark" align="center" label="Description" min-width="260"></el-table-column>
        <el-table-column prop="status" align="center" label="Status" min-width="126">
          <template slot-scope="scope">
            <p class="lh20 mt0 mb0">{{ clientCodeStatusFormat(scope.row.status) }}</p>
            <el-link type="primary" :underline="false" @click="openStatusHistoryModal(scope.row.id)">(Track)</el-link>
          </template>
        </el-table-column>
        <el-table-column align="center" label="Marketing Tags" min-width="140">
          <template slot-scope="scope">
            <p v-if="scope.row.tagList?.length > 0">{{ scope.row.tagList.map(i => i.tagName)?.join(" ,") }}</p>
          </template>
        </el-table-column>
        <el-table-column align="center" width="120" fixed="right" label="Action">
          <template slot-scope="scope">
            <!-- 编辑全部信息 -->
            <el-button
              v-if="isAuth('sys:client:update') && (scope.row.status == 0 || scope.row.status == 2)"
              type="text"
              class="fwb"
              @click="addOrUpdateHandle(scope.row)"
            >
              Edit
            </el-button>
            <!-- 编辑部分基础信息 -->
            <el-button
              v-if="isAuth('sys:client:updateBaseInfo') && scope.row.status != 0 && scope.row.status != 2"
              type="text"
              class="fwb"
              @click="updateBaseHandle(scope.row)"
            >
              Quick Edit
            </el-button>
            <el-button
              v-if="isAuth('sys:client:audit') && (scope.row.status == 0 || scope.row.status == 2)"
              type="text"
              class="fwb ml0"
              @click="reviewHandle(scope.row)"
            >
              Review
            </el-button>
            <el-button v-if="isAuth('sys:client:delete')" type="text" class="fwb ml0" @click="deleteHandle(scope.row)">Delete</el-button>
            <!-- 审核通过后的修改 -->
            <el-button
              v-if="isAuth('sys:client:revise') && scope.row.status == 1"
              type="text"
              class="fwb ml0"
              @click="statusUpdateHandle(scope.row, 0, 'Revise')"
            >
              Revise
            </el-button>
            <!-- 禁用 -->
            <el-button
              v-if="isAuth('sys:client:inactive') && scope.row.status != 3"
              type="text"
              class="fwb ml0"
              @click="statusUpdateHandle(scope.row, 3, 'Inactive')"
            >
              Inactive
            </el-button>
            <!-- 禁用后，再启用 -->
            <el-button
              v-if="isAuth('sys:client:reActive') && scope.row.status == 3"
              type="text"
              class="fwb ml0"
              @click="statusUpdateHandle(scope.row, 0, 'Re-active')"
            >
              Re-active
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <pagination
      :current="current"
      :pageSize="pageSize"
      :totalCount="totalCount"
      @size-change="sizeChangeHandle"
      @current-change="currentChangeHandle"
    ></pagination>

    <!-- 弹窗, 新增 / 修改 -->
    <add-or-update
      ref="addOrUpdate"
      :userList="userList"
      :tagInfoList="tagInfoList"
      :commissionRequiredList="commissionRequiredList"
      @refreshDataList="getDataList"
    ></add-or-update>
    <!-- 编辑部分基础信息 - 弹窗 -->
    <update-base-info
      ref="updateBaseInfoModal"
      :userList="userList"
      :tagInfoList="tagInfoList"
      :commissionRequiredList="commissionRequiredList"
      @refreshDataList="getDataList"
    ></update-base-info>
    <!-- 关联申请日志 - 弹窗 -->
    <linked-applymenty ref="linkedApplymentyModal"></linked-applymenty>
    <!-- 状态操作日志弹框 -->
    <status-history ref="statusHistoryModal"></status-history>
    <!-- client code 复核弹框 -->
    <client-review ref="clientReviewModal" @refreshStatus="getDataList"></client-review>
  </div>
</template>

<script>
import AddOrUpdate from "./modal/AddOrUpdate";
import UpdateBaseInfo from "./modal/UpdateBaseInfo";
import LinkedApplymenty from "./modal/LinkedApplymenty";
import StatusHistory from "./modal/StatusHistory";
import ClientReview from "./modal/ClientReview";
import ElSelectAll from "@/components/ElSelectAll";
import ElDatePickerRange from "@/components/ElDatePickerRange";
import ClientCodeSelectRemoteSearch from "@/components/SelectRemoteSearch/clientCode";
import UenSelectRemoteSearch from "@/components/SelectRemoteSearch/uen";
import Pagination from "@/components/Pagination";
import searchMixin from "@/mixins/searchMixin";
import tableMixin from "@/mixins/tableMixin";
import paginationMixin from "@/mixins/paginationMixin";
import formatterMixin from "@/mixins/formatterMixin";
import { multiply } from "@/utils/count";
import { isNumberLike } from "@/utils";
import { mapState } from "vuex";
export default {
  mixins: [searchMixin, tableMixin, paginationMixin, formatterMixin],
  components: {
    AddOrUpdate,
    UpdateBaseInfo,
    LinkedApplymenty,
    StatusHistory,
    ClientReview,
    ElSelectAll,
    ElDatePickerRange,
    ClientCodeSelectRemoteSearch,
    UenSelectRemoteSearch,
    Pagination,
  },
  data() {
    return {
      kwTypes: [
        {
          title: "Company Name",
          value: "companyName",
          placeholder: "Company Name",
        },
        {
          title: "Relationship",
          value: "relationship",
          placeholder: "Relationship",
        },
        {
          title: "Billing Address",
          value: "billingAddress",
          placeholder: "Billing Address",
        },
        {
          title: "Attention",
          value: "attention",
          placeholder: "Attention",
        },
        {
          title: "Contact Info",
          value: "contact",
          placeholder: "Contact Info",
        },
        {
          title: "Introducer",
          value: "introducer",
          placeholder: "Introducer",
        },
        {
          title: "Description",
          value: "remark",
          placeholder: "Description",
        },
      ],
      dataForm: {
        kwType: "companyName",
        keyword: "",
        country: "",
        coordinatorIds: [],
        status: "",
        clientCode: "",
        uen: "",
        remark: "",
        contact: "",
        createTimeStart: "",
        createTimeEnd: "",
        passTimeStart: "",
        passTimeEnd: "",
        introducedBy: null,
        introducer: "",
        commission: [],
        tagIds: [],
        "orders[0].asc": false,
        "orders[0].column": "id",
      },
      dataList: [],
      dataListLoading: false,
      commissionRequiredList: [],
      userList: [],
      tagInfoList: [],
    };
  },
  computed: {
    ...mapState("constant", ["clientCodeStatusList", "countryList", "introducedByList"]),
    multiply() {
      return val => {
        if (isNumberLike(val)) {
          const newVal = multiply(val, 100);
          return `${Number(newVal)}%`;
        } else {
          return "";
        }
      };
    },
    commissionRequiredArr() {
      const itemData = this.commissionRequiredList.map(item => {
        return { title: `${item.name} - ${this.multiply(item.commissionRate)}`, value: item.id };
      });
      return itemData;
    },
  },
  methods: {
    // 用户列表
    getSysUserList() {
      return new Promise((resolve, reject) => {
        this.$http
          .get(`/admin/sysUser/getList`)
          .then(res => {
            const resData = res.data || [];
            this.userList = resData;
            resolve();
          })
          .catch(err => {
            reject();
          });
      });
    },
    // 获取渠道商列表
    getCommissionRequiredList() {
      return new Promise((resolve, reject) => {
        this.$http
          .get("/admin/stCommission/getList")
          .then(res => {
            const resData = res.data || [];
            this.commissionRequiredList = resData;
            resolve();
          })
          .catch(err => {
            reject();
          });
      });
    },
    // 获取标签列表
    getTagInfoList() {
      return new Promise((resolve, reject) => {
        this.$http
          .get("/admin/clientTagInfo/getList")
          .then(res => {
            this.tagInfoList = res.data || [];
            resolve();
          })
          .catch(err => {
            reject();
          });
      });
    },
    // 获取数据分页
    async getDataList(current) {
      this.dataListLoading = true;
      if (current) {
        this.current = current;
      }
      const dataFormCopy = JSON.parse(JSON.stringify(this.dataForm));
      const coordinatorIds = dataFormCopy.coordinatorIds;
      const unassignedIdx = coordinatorIds.indexOf("unassigned");
      if (unassignedIdx != -1) {
        dataFormCopy.isCoordinatorUnlinked = 1;
        dataFormCopy.coordinatorIds.splice(unassignedIdx, 1);
      } else {
        dataFormCopy.isCoordinatorUnlinked = 0;
      }
      const params = {
        current: this.current,
        size: this.pageSize,
        ...dataFormCopy,
        [this.dataForm.kwType]: this.dataForm.keyword,
      };
      const { code, data } = await this.$http.get("/admin/clientCodeInfoManage/paging", {
        params,
      });
      if (code === 200) {
        this.dataList = data.records;
        this.totalCount = data.total;
      } else {
        this.dataList = [];
        this.totalCount = 0;
      }
      this.dataListLoading = false;
    },
    // Introduced By - Change
    introducedByChange() {
      if (!this.dataForm.introducedBy) {
        this.$set(this.dataForm, "commission", []);
      }
    },
    // 状态操作日志
    openStatusHistoryModal(id) {
      this.$refs.statusHistoryModal.init(id);
    },
    // 关联申请日志
    openLinkedApplymentyModal(data) {
      this.$refs.linkedApplymentyModal.init(data);
    },
    // 新增 / 修改
    addOrUpdateHandle(row) {
      this.$refs.addOrUpdate.init(row);
    },
    // 编辑部分基础信息
    updateBaseHandle(row) {
      this.$refs.updateBaseInfoModal.init(row);
    },
    // 删除
    async deleteHandle(row) {
      if (row.hasLinkedTransactions) {
        this.$message({
          type: "warning",
          dangerouslyUseHTMLString: true,
          message: `<div>
          <strong>Delete failed.</strong>
          <p class="mt4 lh16">Please check with linked transactions at "Engagement" section, and delete those linked transactions before this action.</p>
          </div>`,
        });
        return;
      }
      await this.$confirm(`Delete this Client code. Continue?`, "Warning", {
        confirmButtonText: "OK",
        cancelButtonText: "Cancel",
        type: "warning",
      });
      const { code, msg } = await this.$http.post(`/admin/clientCodeInfoManage/${row.id}/delete`, {});
      if (code === 200) {
        this.$message({
          message: "success",
          type: "success",
          duration: 1500,
          onClose: () => {
            // mixins
            this.singleDataDelete();
            this.getDataList();
          },
        });
      } else {
        this.$message.error(msg);
      }
    },
    // 复核
    reviewHandle(row) {
      this.$refs.clientReviewModal.init(row);
    },
    // 审核通过后的修改、禁用、禁用后启用
    async statusUpdateHandle(row, status, tipe) {
      await this.$confirm(`${tipe} this Client code. Continue?`, "Warning", {
        confirmButtonText: "OK",
        cancelButtonText: "Cancel",
        type: "warning",
      });
      this.$http.post(`/admin/clientCodeInfoManage/${row.id}/audit`, { status }).then(({ code, msg }) => {
        if (code === 200) {
          this.getDataList();
          this.$message.success("success");
        } else {
          this.$message.error(msg);
        }
      });
    },
  },
  async activated() {
    try {
      this.dataListLoading = true;
      await this.getSysUserList();
      await this.getCommissionRequiredList();
      await this.getTagInfoList();
    } catch (error) {
    } finally {
      this.getDataList();
    }
  },
};
</script>

<style lang="scss" scoped>
.fml10 {
  margin-left: -10px;
}

.controlLeft {
  ::v-deep input {
    // border-right: none;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
  ::v-deep .el-input__inner:focus {
    border-color: #dcdfe6 !important;
  }

  ::v-deep .el-input__inner.is-focus {
    border-color: #dcdfe6 !important;
  }

  ::v-deep .el-input:focus {
    .el-input__inner {
      border-color: #dcdfe6 !important;
    }
  }

  ::v-deep .el-input.is-focus {
    .el-input__inner {
      border-color: #dcdfe6 !important;
    }
  }
}

.controlRight {
  border-left: none;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;

  ::v-deep input {
    border-left: none;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
}

.lightGray {
  color: #bfcbd9;
}
</style>
